import { ClientTabs } from 'src/components/SidePanelTabs/ClientTab/client-const';
import { create, StateCreator } from 'zustand';
import { persist } from 'zustand/middleware';

export interface ClientViewState {
  selectedClientTab: ClientTabs;
  setSelectedClientTab: (item: ClientTabs) => void;
  clientSidePanelStateOpen: boolean;
  setClientSidePanelStateOpen: (data: boolean) => void;
}

export const createClientViewSlice: StateCreator<ClientViewState, [], [], ClientViewState> = (
  set,
) => ({
  selectedClientTab: ClientTabs.Sites,
  setSelectedClientTab: (selectedClientTab) => set({ selectedClientTab }),
  clientSidePanelStateOpen: true,
  setClientSidePanelStateOpen: (data) =>
    set(() => ({
      clientSidePanelStateOpen: data,
    })),
});

const useClientViewsStore = create<ClientViewState>()(
  persist(
    (...args) => ({
      ...createClientViewSlice(...args),
    }),
    {
      name: 'portal-client-view-store',
    },
  ),
);

export default useClientViewsStore;
